export const Constant = {
  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,

  INITIAL_SKEW_X: 0,
  FINAL_SKEW_X: -Math.PI / 6,

  INITIAL_SKEW_Y: 0,
  FINAL_SKEW_Y: -Math.PI / 6,

  DAMPING: 4,
  REST_SPEED_THRESHOLD: 0.01,
  STIFFNESS: 100,
  VELOCITY: 4,
};
